import { render } from "./SatelitalList.component.vue?vue&type=template&id=99f3b9d6&scoped=true&ts=true"
import script from "./SatelitalList.component.vue?vue&type=script&lang=ts"
export * from "./SatelitalList.component.vue?vue&type=script&lang=ts"

import "./SatelitalList.component.vue?vue&type=style&index=0&id=99f3b9d6&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99f3b9d6"]])

export default __exports__